<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import EditVariantInMarkets from '@/components/price-managment/modals/EditVariantInMarkets.vue'
import EditMarketPlaceProductModal from '@/components/price-managment/modals/EditMarketPlaceProduct.vue'
import EditVariantModal from '@/components/price-managment/modals/EditVariant.vue'
import {
    getLinkedMarketPlaceProductRequest,
    setLinkedMarketPlaceProductRequest,
    getVariantRequest,
    setProductVariantsRequest,
    setVariantRequest,
    switchVariantStatusRequest
} from "@/api/product";

DataTable.use(DataTablesCore);

export default {
    components: { DataTable, EditVariantInMarkets, EditMarketPlaceProductModal, EditVariantModal },
    props: { locale: null },
    data() {

        return {
            showLoading: false,
            products: null,
            variant: null,
            linkedMarketPlaceProduct: null,
            search: null
        };
    },
    mounted() {

        const getVariant = this.getVariant;
        const getMarketPlaceProduct = this.getMarketPlaceProduct;
        const appUrl = process.env.MIX_API_URL
        const locale = this.locale
        const switchLinkedProduct = this.switchLinkedProduct;
        const switchVariant = this.switchVariant;
        const langFile = (locale == 'ar') ? "Arabic.json" : "English.json"
        $(() => {


            var dt = $('#products_table').DataTable({
                processing: true,
                serverSide: true,
                "searching": true,
                paging: true,
                "language": {
                    "url": window.location.origin + "/" + langFile
                },
                ajax: {
                    url: appUrl + 'variants',
                    data: function (datatable) {
                        datatable.filter = $('#datatable_filter').serializeJSON();
                        return datatable;
                    },
                    headers: {
                        "locale": locale
                    }
                },
                columns: [
                    {
                        className: "dt-control min-w-40px ",
                        orderable: false,
                        data: null,
                        defaultContent: "",
                        render: function (data) {
                            // if (data.linked_marketplace_products.length == 0)
                            //     return '';
                            return `<div class="icons-container">
                            <div class="plus-icon-container">
                                <img src="${window.location.origin}/assets/image/plus-icon.svg" />
                            </div>

                            <div class="minus-icon-container">
                                <img src="${window.location.origin}/assets/image/minus-icon.svg" />
                            </div>

                            </div>
                            `;
                        },
                    },
                    {
                        data: null, title: this.$t('product'),
                        defaultContent: "-",
                        width: "20%",
                        render: function (data, type, row) {
                            return '<p><img class="thumb-img" src="' + data.Thumbnail + '" /> ' + data.product.available_name + '</p>'
                        }
                    },
                    {
                        data: "product.sku", title: this.$t('sku'),
                        width: "20%",
                        defaultContent: "-"
                    },
                    {
                        data: "product.category.available_name", title: this.$t('category'),
                        width: "10%",
                        defaultContent: "-"
                    },
                    {
                        data: null,
                        orderable: false,
                        width: "10%",
                        title: this.$t('marketPlaces'),
                        // className: "w-20px text-end",
                        render: function (data) {
                            let logos = [];
                            let images = '-';
                            data.linked_marketplace_products.forEach(element => {
                                if (element.marketplace.logo_url != '' && !logos.includes(element.marketplace.logo_url)) {
                                    logos.push(element.marketplace.logo_url);
                                }
                            });

                            logos.forEach(logo => {
                                images += '<img src="' + logo + '" class="market-place-logo" />'
                            })
                            return images;
                        },
                    },
                    {
                        data: "product.manufacturer.available_name", title: this.$t("manufacturer"),
                        width: "10%",
                    },
                    {
                        data: "identifier_type", title: this.$t("identifierType"),
                        width: "10%",
                        defaultContent: "-"
                    },
                    {
                        data: null,
                        orderable: false,
                        width: "10%",
                        title: this.$t("firstOption"),
                        // className: "w-20px text-end",
                        render: function (data) {
                            let text = '-';
                            if (data.option_values.length > 0 && data.option_values[0] != undefined && data.option_values[0].option.available_name != null)
                                text = '<p>' + data.option_values[0].option.available_name + ':' + data.option_values[0].available_name + '</p>'
                            return text;
                        },
                    },
                    {
                        data: null,
                        orderable: false,
                        width: "10%",
                        title: this.$t("secondOption"),
                        // className: "w-20px text-end",
                        render: function (data) {
                            let text = '-';
                            if (data.option_values.length > 0 && data.option_values[1] != undefined && data.option_values[1].option.available_name != null)
                                text = '<p>' + data.option_values[1].option.available_name + ':' + data.option_values[1].available_name + '</p>'

                            return text;
                        },
                    },
                    {
                        data: null,
                        orderable: false,
                        width: "10%",
                        title: this.$t("thirdOption"),
                        // className: "w-20px text-end",
                        render: function (data) {
                            let text = '-';
                            if (data.option_values.length > 0 && data.option_values[2] != undefined && data.option_values[2].option.available_name != null)
                                text = '<p>' + data.option_values[2].option.available_name + ':' + data.option_values[2].available_name + '</p>'
                            return text;
                        },
                    },
                    {
                        data: null,
                        orderable: false,
                        title: this.$t("actions"),
                        className: "text-end",
                        render: function (data) {
                            if (data.linked_marketplace_products_count > 0)
                                return '<button class="edit-variant-in-markets" data-bs-toggle="modal" data-id="' + data.id + '" data-bs-target="#edit_variant_in_market" ><img data-id="' + data.id + '" src="' + window.location.origin + '/assets/image/edit-btn.svg" /></button>';
                            else
                                return '<button class="edit-variant" data-bs-toggle="modal" data-id="' + data.id + '" data-bs-target="#edit_variant" ><img data-id="' + data.id + '" src="' + window.location.origin + '/assets/image/edit-btn.svg" /></button>'
                        },
                    },
                ],
                columnDefs: [{
                    targets: 0,
                    render: function (data, type, row) {
                        return data.substr(0, 15);
                    }
                }],
                pageLength: 10

            });

            window.table = dt
            const filterSearch = document.querySelector('[data-kt-docs-table-filter="variant-search"]');
            filterSearch.addEventListener('keyup', function (e) {
                dt.search(e.target.value).draw();
            });

            dt.on('draw', function () {
                $('.edit-variant-in-markets').on('click', (e) => {
                    getVariant(e.target.getAttribute('data-id'))
                })
                $('.edit-variant').on('click', (e) => {
                    getVariant(e.target.getAttribute('data-id'))
                })

            })
            dt.on('click', 'td.dt-control', (e) => {
                let tr = e.target.closest('tr');
                let row = dt.row(tr);

                if (row.child.isShown()) {
                    // This row is already open - close it
                    row.child.hide();
                }
                else {


                    var text = '';
                    if (row.data().linked_marketplace_products_count > 0) {
                        text =
                            '<div class="table-responsive"><table class="table sub-table"><thead><tr><th>' + this.$t('marketPlaces') + '</th><th>' + this.$t('quantity') + '</th><th>' + this.$t('sellingPrice') + '</th><th>' + this.$t('priceAfterDiscount') + '</th><th>' + this.$t('available') + '</th><th>' + this.$t('actions') + '</th></tr></thead><tbody>';
                        row.data().linked_marketplace_products.map((v) => {

                            text +=
                                '<tr><td><img src="' + v.marketplace.logo_url + '" class="market-place-logo" /></td>';
                            text += "<td>" + v.quantity + "</td>";

                            text +=
                                "<td>" +
                                v.selling_price +
                                "</td>";
                            text +=
                                "<td>" +
                                v.discounted_price +
                                "</td>";
                            text += `<td><div class="form-check form-switch">
                            <input  data-variant-id="${(v.status == "LISTED") ? v.id : v.variant_id}" data-linked-marketplace-id="${v.linked_marketplace_id}" ${(v.status == "LISTED" ? 'checked' : '')} class="form-check-input linked-product-switch" type="checkbox" role="switch" id="linked-product-switch-${(v.status == "LISTED") ? v.id : v.variant_id}">
                            </div></td>`;

                            text += '<td><button class="edit-marketplace-product" data-bs-toggle="modal" data-id="' + v.id + '" data-bs-target="#edit_marketplace_linked_product" ><img data-id="' + v.id + '" src="' + window.location.origin + '/assets/image/edit-btn.svg" /></button></td></tr>';


                        });
                        text += "</tbody></table> </div>";
                    } else {
                        var variantData = row.data()
                        var discounted_price = (variantData?.discount?.amount) ? variantData.price - variantData?.discount?.amount : variantData.price

                        text =
                            '<div class="table-responsive"><table class="table sub-table"><thead><tr><th>' + this.$t('marketPlaces') + '</th><th>' + this.$t('quantity') + '</th><th>' + this.$t('sellingPrice') + '</th><th>' + this.$t('priceAfterDiscount') + '</th><th>' + this.$t('available') + '</th><th>' + this.$t('actions') + '</th></tr></thead><tbody>';

                        text +=
                            '<tr><td>-</td>';
                        text += "<td>" + variantData.quantity + "</td>";

                        text +=
                            "<td>" +
                            variantData.price +
                            "</td>";
                        text +=
                            "<td>" +
                            discounted_price +
                            "</td>";

                        text += `<td><div class="form-check form-switch">
                            <input  data-variant-id="${variantData.id}"  ${(variantData.status == "ACTIVE" ? 'checked' : '')} class="form-check-input variant-switch" type="checkbox" role="switch" id="variant_${variantData.id}">
                            </div></td>`;
                        text += '<td><button class="edit-variant" data-bs-toggle="modal" data-id="' + variantData.id + '" data-bs-target="#edit_variant" ><img data-id="' + variantData.id + '" src="' + window.location.origin + '/assets/image/edit-btn.svg" /></button></td></tr>';


                        text += "</tbody></table> </div>";
                    }
                    row.child(text).show();
                    $('.edit-variant').on('click', (e) => {
                        getVariant(e.target.getAttribute('data-id'))
                    })
                    $('.linked-product-switch').on('change', function (e) {

                        const variant_id = this.getAttribute('data-variant-id')
                        const linked_market_id = this.getAttribute('data-linked-marketplace-id')
                        const status = (this.checked) ? 'enable' : 'disable'

                        switchLinkedProduct(linked_market_id, variant_id, status)

                    })

                    $('.variant-switch').on('change', function (e) {

                        const variant_id = this.getAttribute('data-variant-id')
                        const status = (this.checked) ? 'enable' : 'disable'

                        switchVariant(variant_id, status)

                    })
                    $('.edit-marketplace-product').on('click', (e) => {
                        getMarketPlaceProduct(e.target.getAttribute('data-id'))
                    })

                }
            });
        })

    },
    methods: {
        updateVariantInMarkets(data) {
            this.ApiService(setProductVariantsRequest(data))
                .then(() => {
                    document.getElementById('close').click();
                    swalToastFire('success');
                })
                .catch(e => {
                    var errArr = []
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        errArr.push(value)
                    }
                    swalToastFire('error', this.$t('validationError'), errArr);
                })
                .finally(() => {
                    this.showLoading = false;
                });
        },
        switchLinkedProduct(linked_market_id, variant_id, status) {
            this.showLoading = true;
            const params = {
                linked_market_id,
                variant_id
            }
            const btnId = `#linked-product-switch-${variant_id}`
            if (status == 'enable')
                swalConfirmFire(`${process.env.MIX_API_URL}linked_product/${params.linked_market_id}/list_product/${params.variant_id}?api=true`, this.$t('listProduct'), this.$t('generalConfirmationMsg'), btnId);

            else {
                swalConfirmFire(`${process.env.MIX_API_URL}linked_product/${params.linked_market_id}/unlist_product/${params.variant_id}?api=true`, this.$t('unlistProduct'), this.$t('generalConfirmationMsg'), btnId);

            }
        },
        switchVariant(variant_id, status) {
            this.showLoading = true;
            const data = {
                variant_id,
                status
            }
            const btnId = `#variant_${variant_id}`
            swalConfirmFire(`${process.env.MIX_API_URL}variants/updateStatus/${data.status}/${data.variant_id}?api=true`, '', this.$t('generalConfirmationMsg'), btnId);
        },
        getVariant(id) {
            this.$refs.editVariantInMarkets.reset()
            this.$refs.editVariantModal.reset()
            this.variant = null

            this.ApiService(getVariantRequest(id))
                .then(({ data }) => {
                    this.variant = data.result
                })
                .finally(() => {
                    this.showLoading = false;
                });
        },
        getMarketPlaceProduct(id) {
            this.$refs.editMarketPlaceProductModal.reset()
            this.linkedMarketPlaceProduct = null
            this.ApiService(getLinkedMarketPlaceProductRequest(id))
                .then(({ data }) => {
                    this.linkedMarketPlaceProduct = data.result
                })
                .finally(() => {
                    this.showLoading = false;
                });
        },
        updateLinkedMarketPlaceProduct(data) {
            this.ApiService(setLinkedMarketPlaceProductRequest(data))
                .then(() => {
                    document.getElementById('close').click();
                    swalToastFire('success');
                })
                .catch(e => {
                    var errArr = []
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        errArr.push(value)
                    }
                    swalToastFire('error', this.$t('validationError'), errArr);
                })
                .finally(() => {
                    this.showLoading = false;
                });
        },
        updateVariant(data) {
            this.ApiService(setVariantRequest(data))
                .then(() => {
                    document.getElementById('close').click();
                    swalToastFire('success');
                })
                .catch(e => {
                    var errArr = []
                    for (const [key, value] of Object.entries(e.response.data.errors)) {
                        errArr.push(value)
                    }
                    swalToastFire('error', this.$t('validationError'), errArr);
                })
                .finally(() => {
                    this.showLoading = false;
                });
        }
    },
};
</script>

<template>
    <!-- <DataTable
        ref="table"
        :columns="columns"
        :data="products"
        id="products_table"
        class="vue-tables"
        :options="{
            searching: false,
            paging: false,
        }"
    >
    </DataTable> -->
    <table id="products_table" class="vue-tables"></table>
    <EditVariantInMarkets ref="editVariantInMarkets" :variant="variant" @handleVariantUpdate="updateVariantInMarkets">
    </EditVariantInMarkets>
    <edit-market-place-product-modal ref="editMarketPlaceProductModal" :linkedMarketplaceProduct="linkedMarketPlaceProduct"
        @handleLinkedMarketplaceProductUpdate="updateLinkedMarketPlaceProduct"></edit-market-place-product-modal>
    <edit-variant-modal ref="editVariantModal" :variant="variant" @handleVariantUpdate="updateVariant"></edit-variant-modal>
</template>
<style>
.vue-tables .plus-icon-container {
    background-color: #fff;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.vue-tables .thumb-img {
    max-width: 50px;
    margin: 0px 10px;
}

.vue-tables .plus-icon {
    fill: rgba(88, 88, 88, 0.9);
}

.vue-tables .minus-icon-container {
    background-color: rgba(236, 85, 47, 0.1);
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: none;
}

.vue-tables .minus-icon {
    fill: #ec552f;
}

.vue-tables .market-place-logo {
    width: 20px;
}

.vue-tables .dt-hasChild .plus-icon-container {
    display: none;
}

.vue-tables .dt-hasChild .minus-icon-container {
    display: block;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.vue-tables .delete-btn,
.vue-tables .edit-btn,
.vue-tables .edit-variant,
.edit-variant-in-markets,
.edit-marketplace-product {
    background-color: #fff;
    border: none;
    width: 35px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
}

.vue-tables .delete-btn {
    background-color: rgba(236, 85, 47, 0.1);
}

.vue-tables .delete-btn svg {
    fill: rgb(236, 85, 47);
}

.vue-tables tbody tr.odd,
.vue-tables tbody tr.even {
    border-bottom: 2px solid #fff;
}

.vue-tables tbody tr.dt-hasChild {
    border-bottom: none;
}

.vue-tables th,
.vue-tables td {
    padding: 25px 0;
}

.vue-tables .switch {
    display: inline-block;
    position: relative;
    width: 50px;
    height: 25px;
    border-radius: 20px;
    background: #dfd9ea;
    transition: background 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    vertical-align: middle;
    cursor: pointer;
}

.vue-tables .switch::before {
    content: "";
    position: absolute;
    top: 1px;
    left: 2px;
    width: 22px;
    height: 22px;
    background: #fafafa;
    border-radius: 50%;
    transition: left 0.28s cubic-bezier(0.4, 0, 0.2, 1),
        background 0.28s cubic-bezier(0.4, 0, 0.2, 1),
        box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.vue-tables .switch:active::before {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28),
        0 0 0 20px rgba(128, 128, 128, 0.1);
}

.vue-tables input:checked+.switch {
    background: #ec552f;
}

.vue-tables input:checked+.switch::before {
    left: 27px;
    background: #fff;
}

.vue-tables input:checked+.switch:active::before {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), 0 0 0 20px rgba(0, 150, 136, 0.2);
}

.vue-tables table.sub-table,
.vue-tables .sub-table th,
.vue-tables .sub-table td {
    border: 2px solid #fff;
    border-collapse: collapse;
}

.vue-tables .sub-table th {
    font-weight: bolder;
    font-size: 14px;
    padding-inline-start: 10px;
}

.vue-tables .sub-table td {
    padding-inline-start: 10px;
}

.vue-tables .remove-border-btn {
    border-bottom: none;
}

/* html[dir="rtl"] .paginate_button.page-item.previous {
    transform: rotate(180deg);
} */
</style>
